import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-KQ-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 61.98 55.54"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-KQ-logo_svg__cls-1{fill:#ec2227}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      id: "svg-KQ-logo_svg__path5",
      d: "M45.12 3.34s-8.88-5.59-20.56-2.3c0 0-15.71 4.52-21.14 17.18 0 0-7.31 11.76-.57 24.75 0 0 4.04 9.1 14.8 11.68 0 0 13.76 3.7 23.85-3.94 0 0 15.23-8.04 15.62-25.01 0 0 1.48-14.96-12-22.36m7.39 29.59c-2.79 7.56-15.29 15.95-15.29 15.95-22.36 11.18-31.09-5.03-31.09-5.03-4.93-10.52 1.1-20.56 1.1-20.56C12.99 11.95 23.9 7.45 23.9 7.45c15.29-6.58 24.01.82 24.01.82 12.33 9.21 4.6 24.66 4.6 24.66",
      class: "svg-KQ-logo_svg__cls-1"
    }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      id: "svg-KQ-logo_svg__path7",
      d: "M20.6 16.78s-6.01 14.05-6.09 14.89c0 0-2.12 6.6-1.1 13.03l10.64.31s-2.94-1.42-1.08-8.95c0 0 1.27-4.49 2.2-4.82 0 0 .25-.42.42.34 0 0 2.11 7.61 7.79 13.37 0 0 3.55 4.91 12.35 8.29 0 0 7.7 2.03 12.27-1.77 0 0 3.89-2.37 3.97-9.23 0 0 .07-.69-.59-.17 0 0-2.88 3.21-10.24 2.62 0 0-2.2.42-8.29-4.23L29.9 29.8s-.59-.42.25-.51c0 0 7.53-1.35 9.73-3.13 0 0 6.77-3.33 7.7-8.29 0 0 1.4-5.44-.76-8.63 0 0-.76-.51-1.01.08 0 0-3.87 3.99-7.21 6.14l-9.97 6.47s-.76.51-.17-.68l2.88-7.62s1.61-2.62-2.79-2.28c0 0-6.63.67-10.3 5.19 0 0-.28.14.23.31l2.12-.08Z",
      class: "svg-KQ-logo_svg__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "KQ-logo"}) } }